import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const useRankings = (accountID, month) =>
    useQuery({
        queryKey: ["rankings", accountID, month],
        queryFn: () =>
            axios.get(`/api/${accountID}/rankings`, { params: { month } }).then(res => res.data),
        enabled: !!month
    });

export const useRankingsMonths = accountID =>
    useQuery({
        queryKey: ["rankings-months", accountID],
        queryFn: () => axios.get(`/api/${accountID}/rankings/months`).then(res => res.data)
    });

export const useShowRankings = (accountID, showID) =>
    useQuery({
        queryKey: ["show-rankings", accountID, showID],
        queryFn: () => axios.get(`/api/${accountID}/rankings/shows/${showID}`).then(res => res.data)
    });
